/**
 * «OFFRI PATTA» SI VEDE? (E7 di ADR-0193; QChess `PRATICA.md` D7: il bot rifiuta SEMPRE la patta, quindi nella pratica il
 * bottone e' una promessa che non puo' riuscire). Puro: niente `@/`, niente React, niente `import.meta.env`.
 *
 * Si legge UN solo campo, `MatchStatePayload.practice` (board-ui 0.4.0, QChess#44): `false` SOLO con `practice === true`.
 * Il tipo lo vuole obbligatorio, ma un game host di prima non lo manda: assente vale «non lo so», e nel dubbio il bottone resta
 * com'era. ⛔ Mai un'euristica sul nome del bot, sul `mode` o sullo `userId`: il game host e' l'unico a sapere cos'e' una pratica.
 */
export const offertaPattaVisibile = (state: { readonly practice?: boolean }): boolean => state.practice !== true;
